<div class="new-message-chat" style="
    background-color: white;
    width: 400px;
    height: 500px;
    overflow-y: auto;
    padding: 15px;
  ">
  <h4 class="card-header d-flex justify-content-between align-items-center mb-0">
    {{ selectedUser ? selectedUser : "NEWMSG.NEW_MSG" | translate }}
    <button mat-button (click)="close()">
      {{ "NEWMSG.CANCEL" | translate }}
    </button>
  </h4>

  <div class="input-group" *ngIf="!selectedUser">
    <form [formGroup]="usersForm" class="example-form">
      <div class="search-input d-flex align-items-center">
        <!-- <mat-icon style="position: absolute; left: 5px">search</mat-icon>
        <input matInput type="text" class="form-control" [placeholder]="'NEWMSG.CHOOSE_USER' | translate"
          [matAutocomplete]="auto" formControlName="userInput" /> -->
        <mat-form-field style="width: 100%;" subscriptSizing="dynamic">
          <input matInput type="text" class="form-control" formControlName="userInput"
            [placeholder]="'NEWMSG.CHOOSE_USER' | translate" [matAutocomplete]="auto" />
          <button matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
        <mat-option *ngIf="isLoading" class="is-loading"><mat-spinner diameter="50"></mat-spinner></mat-option>
        <ng-container *ngIf="!isLoading">
          <mat-option *ngFor="let user of filteredUserList" [value]="user" (onSelectionChange)="onSelFunc(user)"
            class="new-message-search-results p-2">
            <span>{{ user.user.name }}</span>
            <small>
              | {{ "NEWMSG.EMAIL" | translate }} {{ user.user.email }}</small>
            <small>
              | {{ "NEWMSG.PHONE" | translate }}
              {{ user.user.PhoneNumber }}</small>
          </mat-option>
        </ng-container>
      </mat-autocomplete>
    </form>
  </div>

  <ng-template #dynamicallChat></ng-template>
</div>